import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { WordReveal } from '@/components/ui/word-reveal';

export function FinalCta() {
  return (
    <section className="bg-white py-16 md:py-20 border-t border-gray-100 relative overflow-hidden">
      <div className="mx-auto w-full max-w-7xl 2xl:max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30, filter: 'blur(8px)' }}
          whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-3xl bg-gradient-to-r from-[#e8f7f0] via-[#f0fdf4] to-[#e8f7f0] border border-[#d1edd9] p-8 sm:p-10 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 shadow-sm overflow-hidden"
        >
          {/* Ambient Glow */}
          <div className="pointer-events-none absolute -right-20 -bottom-20 h-64 w-64 rounded-full bg-emerald-400/20 blur-3xl" />

          <div className="flex items-center gap-4 text-left relative z-10 max-w-2xl">
            <div className="space-y-2">
              <WordReveal
                as="h2"
                text="Let's make your compliance journey simple"
                className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight leading-tight"
                stagger={0.05}
              />
              <p className="text-sm sm:text-base text-gray-600 font-normal">
                Join thousands of businesses who trust EcRegi for their legal and compliance needs.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3.5 shrink-0 relative z-10">
            <Link to="/login">
              <button
                type="button"
                className="rounded-xl bg-[#15803d] hover:bg-[#166534] px-6 py-3.5 text-sm font-bold text-white transition-all duration-300 shadow-md shadow-emerald-900/15 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
              >
                Client login
              </button>
            </Link>
            <Link to="/associate/login">
              <button
                type="button"
                className="rounded-xl border border-gray-300 bg-white/90 hover:bg-gray-50 px-6 py-3.5 text-sm font-bold text-gray-900 transition-all duration-300 shadow-2xs hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
              >
                Associate login
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
